import { SettingOutlined } from "@ant-design/icons"
import { type MenuItemType } from "components/Menu/Menu"
import { useFlag } from "modules/flags/flags"
import { useMemo } from "react"
import { useNavigate, useParams } from "react-router"
import { useUserRole } from "services/users"

export function useNotificationSettingsMenuOption() {
	const { data: { isProvider, organizations = [] } = {} } = useUserRole()
	const { clinicalEscalations } = useFlag("clinicalEscalations")
	const { scopeId } = useParams()
	const navigate = useNavigate()

	const currentScopeId =
		scopeId && scopeId !== ":scopeId" ? scopeId : organizations[0]?.id

	const items = useMemo<MenuItemType[]>(() => {
		if (!isProvider || !clinicalEscalations.enabled || !currentScopeId) {
			return []
		}

		const path = `/${currentScopeId}/settings/notifications`

		return [
			{
				key: path,
				icon: <SettingOutlined aria-hidden />,
				label: "Notification settings",
				onClick: () => {
					navigate(path)
				},
			},
		]
	}, [clinicalEscalations.enabled, currentScopeId, isProvider, navigate])

	return { items }
}
